import React, { useEffect, useState } from 'react';
import InputWithLabel from '../../components/shared/fields/InputWithLabel';
import Button from '../../components/shared/buttons/button';
import { showToast } from '../../helpers/Utils';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import { useGetReferralContentQuery, useAddReferralContentMutation } from '../../app/reviewLinksApi/reviewLinksApi';

const Referral = () => {
  const [link, setLink] = useState('');
  const [linkDescription, setLinkDescription] = useState('');
  const { data, isSuccess } = useGetReferralContentQuery();
  const [submitReferral, { isLoading }] = useAddReferralContentMutation();

  useEffect(() => {
    if (isSuccess && data?.data) {
      setLink(data.data.link || '');
      setLinkDescription(data.data.link_description || '');
    }
  }, [data, isSuccess]);

  const handleSubmit = async () => {
    if (!link.trim()) {
      showToast('Please enter a referral link.', 'error');
      return;
    }

    if (!linkDescription.trim()) {
      showToast('Please enter a referral description.', 'error');
      return;
    }

    try {
      await submitReferral({
        link,
        link_description: linkDescription
      }).unwrap();
      showToast('Referral content submitted successfully!', 'success');
    } catch (error) {
      showToast(error?.data?.message || 'Failed to submit referral content.', 'error');
    }
  };
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'blockquote'], // <-- blockquote here
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image'],
      ['clean'],
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'blockquote',
    'list', 'bullet',
    'link', 'image',
  ];
  return (
    <div className="">
      <h3>Referral Content</h3>

      <InputWithLabel
        label="Referral Link"
        placeholder="Enter the referral link"
        value={link}
        onChange={(e) => setLink(e.target.value)}
        className="mb-3"
      />


      <div className='mb-3'>
        <ReactQuill
        modules={modules}
        formats={formats}
        value={linkDescription}
        onChange={(value) => setLinkDescription(value)}
        placeholder="Write your message..."
      />

      </div>
      <Button label={isLoading ? 'Submitting...' : 'Submit'} onClick={handleSubmit} />
    </div>
  );
};

export default Referral;
